import { render, staticRenderFns } from "./WidgetLivraisons.vue?vue&type=template&id=71e315b1&"
import script from "./WidgetLivraisons.vue?vue&type=script&lang=js&"
export * from "./WidgetLivraisons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e315b1')) {
      api.createRecord('71e315b1', component.options)
    } else {
      api.reload('71e315b1', component.options)
    }
    module.hot.accept("./WidgetLivraisons.vue?vue&type=template&id=71e315b1&", function () {
      api.rerender('71e315b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accueil/WidgetLivraisons.vue"
export default component.exports